export default __webpack_public_path__ + "static/media/img-home3.be5a8f19.png";